import React, { useState } from "react";
import IntroVideo from '../videos/Axis_background.mp4';
import VideoComponent from './VideoComponent.js';
import Axis_Logo from '../images/Axis_image6.png';
import PageSEO from "../components/seo/PageSEO";
import { buyBook } from "../services/api";
import { useScrollBehavior } from './useScrollBehavior.js';
import ComingSoonModal from '../components/ComingSoonModal';
import "../styles/home.css";

export default function Book() {
  useScrollBehavior();

  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState("");
  const [modalOpen, setModalOpen] = useState(false);

  /*async function handleBuy() {
    setError("");
    setLoading(true);
    try {
      const data = await buyBook({ productId: "book-digital" });
      if (data.redirectUrl)      window.location.href = data.redirectUrl;
      else if (data.downloadUrl) window.location.href = data.downloadUrl;
      else throw new Error("Unexpected response from checkout");
    } catch (e) {
      setError(e.message || "Checkout failed");
    } finally {
      setLoading(false);
    }
  }*/
 function handleBuy() {
  setModalOpen(true);
}

  return (
    <main className="home">
      <PageSEO
        title="The Book | The Axis"
        description="The Axis — a secular ethical framework built on the Sacred Three. Available as an instant digital download."
        path="/book"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Book",
          "name": "The Axis",
          "author": { "@type": "Person", "name": "Temüjin" },
          "url": (process.env.REACT_APP_SITE_URL || "") + "/book"
        }}
      />

      <div className="home__bg" aria-hidden="true">
        <VideoComponent videoSrc={IntroVideo} />
      </div>

      <section className="home__content">

        {/* ── HERO ── */}
        <div className="module" style={{
          minHeight: '100vh',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div className="home__logo">
            <img src={Axis_Logo} alt="Axis logo" className="axis_logo" />
          </div>
          <span className="about__eyebrow">The Axis</span>
          <h1 className="home__title">The Book</h1>
          <p className="home__subtitle">A Framework for Ethical Living</p>
          <p className="home__copy">
            The Axis is a secular ethical philosophy built on three non-negotiable
            principles — Life, the Planet, and the Social Contract. The book is
            the entry point: the full argument, the full framework, and the
            reasoning behind it.
          </p>
          <p className="home__copy" style={{ marginTop: '0.75rem' }}>
            Written by Temüjin. Available as an instant digital download.
          </p>

          <div className="home__cta" style={{ marginTop: '1.5rem' }}>
            <button
              className="btn btn--primary"
              onClick={handleBuy}
              disabled={loading}
            >
              {loading ? "Processing…" : "Buy & Download"}
            </button>
            <button
              className="btn btn--ghost"
              onClick={() => window.location.href = "/contact"}
            >
              Ask a Question
            </button>
          </div>

          {error && (
            <p style={{ color: '#ff9aa9', marginTop: '1rem', fontSize: '0.9rem' }}>
              {error}
            </p>
          )}
        </div>

        {/* ── WHAT YOU GET ── */}
        <div className="module" style={{
          minHeight: 'auto',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          paddingTop: '4rem',
          paddingBottom: '4rem'
        }}>
          <h2 className="module__heading">What's Included</h2>
          <div className="features__grid" style={{ marginBottom: 0 }}>

            <div className="feature">
              <div className="feature__icon" aria-hidden="true">
                <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 4h14l6 6v18H6V4z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                  <path d="M20 4v6h6" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                  <path d="M10 13h12M10 17h12M10 21h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              </div>
              <h4 className="feature__title">PDF Edition</h4>
              <p className="feature__body">
                Full typeset edition. Readable on any device, printable,
                and formatted for extended reading.
              </p>
            </div>

            <div className="feature">
              <div className="feature__icon" aria-hidden="true">
                <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="5" y="3" width="16" height="22" rx="2" stroke="currentColor" strokeWidth="1.5"/>
                  <path d="M9 8h8M9 12h8M9 16h5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                  <path d="M19 18l8 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              </div>
              <h4 className="feature__title">ePub Edition</h4>
              <p className="feature__body">
                For e-readers and reading apps. Adjustable font size,
                works with iBooks, Kindle app, and Kobo.
              </p>
            </div>

            <div className="feature">
              <div className="feature__icon" aria-hidden="true">
                <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 3l2.5 8h8.5l-7 5 2.5 8-7-5-7 5 2.5-8-7-5h8.5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4 className="feature__title">Instant Access</h4>
              <p className="feature__body">
                Secure download link delivered immediately after purchase.
                No account required. Works on desktop and mobile.
              </p>
            </div>

          </div>

          <div className="home__cta" style={{ marginTop: '2.5rem' }}>
            <button
              className="btn btn--primary"
              onClick={handleBuy}
              disabled={loading}
            >
              {loading ? "Processing…" : "Buy & Download"}
            </button>
          </div>

          {error && (
            <p style={{ color: '#ff9aa9', marginTop: '1rem', fontSize: '0.9rem' }}>
              {error}
            </p>
          )}
        </div>

      </section>
      <ComingSoonModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        title="Coming Soon"
        message="The Axis book is currently in final preparation. It will be available for purchase and instant download shortly. Contact us if you have questions in the meantime."
        />
    </main>
  );
}



/*import React, { useState } from "react";
import PageSEO from "../components/seo/PageSEO";
import "../styles/product.css";
import { buyBook } from "../services/api";
import { useScrollBehavior } from './useScrollBehavior.js'; 

export default function Book() {

  useScrollBehavior();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function handleBuy() {
    setError("");
    setLoading(true);
    try {
      // Expected response shape: { redirectUrl } OR { downloadUrl }
      const data = await buyBook({ productId: "book-digital" });
      if (data.redirectUrl) window.location.href = data.redirectUrl;
      else if (data.downloadUrl) window.location.href = data.downloadUrl;
      else throw new Error("Unexpected response from checkout");
    } catch (e) {
      setError(e.message || "Checkout failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="page">
      <PageSEO
        title="Book | Your App Name"
        description="Buy and download the digital book."
        path="/book"
      />

      <header className="pageHeader">
        <h1>Digital Book</h1>
        <p>Instant download after purchase.</p>
      </header>

      <section className="section">
        <div className="card">
          <h2>Book Title</h2>
          <div className="note">PDF / ePub / Kindle (example)</div>

          <div className="ctaRow">
            <button className="btn btn--primary" onClick={handleBuy} disabled={loading}>
              {loading ? "Processing…" : "Buy & Download"}
            </button>
            <button className="btn btn--ghost" onClick={() => window.location.href = "/contact"}>
              Ask a Question
            </button>
          </div>

          {error ? <div className="error">{error}</div> : null}

          <ul className="bullets">
            <li>Immediate access after purchase</li>
            <li>Secure download link</li>
            <li>Works on desktop and mobile readers</li>
          </ul>
        </div>
      </section>
    </main>
  );
}*/
